var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHefl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.83 45.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HEFL") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.46,49.67C82.46,43.33,76,38,67.7,37.33l-3-3.52h-5.9V30.28H85.41l-3-3.52H26.38l2.95,3.52H55.89v3.53H50l-5.9,7H23.43l-5.9-7.76h-3l3,11.29V55h2.95l2.95-7.05,20.66,3.53c0,4.93,5.61,9.16,11.8,10.22v7.4H48.52L47,65.54H44.09l2.95,7H79.51l2.95-7H79.51L78,69.06H70.65v-7.4C77.44,60.25,82.46,55.31,82.46,49.67Zm-18.3-8.81L67.4,51.44H61.8L58.85,40.86Zm3.54,28.2H58.85V62H67.7Zm4.72-11.63L67.11,40.86c7.38.35,12.4,4.94,12.4,8.81C79.51,52.85,76.55,56,72.42,57.43Z",
    transform: "translate(-14.57 -26.76)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHefl);
export default __webpack_public_path__ + "static/media/HEFL.13f657ed68ef3c36bad40ea080054b54.svg";
export { ForwardRef as ReactComponent };